/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React from "react";
import { useEffect } from "react";
import { useApp } from "../../../contexts";
import { useState } from "react";
import {
  itemsSearch,
  summaryGift,
  summaryEnergy,
  querySubscription,
  itemsBreed,
  itemsSku,
  filterDataSubTop
} from "../../../services/app";
import { useNavigate } from "react-router-dom";
import { ArrowDownIcon } from "../../../components/Icons/ArrowDownIcon";
import Item from "../../../components/Item";
import ItemPrime from "../../../components/ItemPrime";
import ItemSubCard from "../../../components/ItemSubscription/ItemSubCard";
import ItemSubCardMobile from "../../../components/ItemSubscription/ItemSubCardMobile";
import ItemMerchandise from "../../../components/ItemMerchandise";
import ItemTotal from "../../../components/ItemEnergy/ItemTotal";
import { ITEM_TYPES, SORT_TYPE } from "../../../constants";
import { PREPOSITION } from "..";
const MAX_ITEM_HOME = 4;

export const TabAsset = () => {
  const { T, setLoading, user, setPrePosition } = useApp();
  const navigate = useNavigate();
  const paramsSearch = {
    // "statuses" : [ITEM_STATUS.Confirmed] ,
    itemTypes: [],
    page: 1,
    size: MAX_ITEM_HOME,
    sort: SORT_TYPE.CREATED_TIME_DESC,
  };
  const [dataTab, setDataTab] = useState({
    earners: [],
    tradeable: {},
    readOnly: {},
    energy: {},
    subscription: [],
    bonusSub: [],
    physical: [],
    subPayments: []
  });
  const [itemsCategories, setItemsCategories] = useState([])
  const [skus, setSkus] = useState([])
  const loadData = async () => {
    setLoading(true);
    const promises = [];
    promises.push(
      itemsSearch({ ...paramsSearch, itemTypes: [ITEM_TYPES.ITEM_TYPE_DOG] })
    );
    promises.push(summaryGift());
    promises.push(summaryEnergy());
    promises.push(querySubscription());
    promises.push(
      itemsSearch({
        ...paramsSearch,
        itemTypes: [ITEM_TYPES.ITEM_TYPE_PHYSICAL],
      })
    );
    promises.push(itemsBreed(9));
    promises.push(
      itemsSearch({ ...paramsSearch, itemTypes: [ITEM_TYPES.ITEM_TYPE_PRIME], size: 3})
    ); 
    promises.push(
      itemsSku(ITEM_TYPES.ITEM_TYPE_PRIME)
    );

    Promise.all(promises).then((result) => {
      const dataEarners = result[0].data?.data?.items?.rows || [];
      const resSubscriptions = result[3].data?.data;
      let dataSubscriptions = [];
      if (Array.isArray(resSubscriptions?.market)) {
        dataSubscriptions = [...dataSubscriptions, ...resSubscriptions.market];
      }
      if (Array.isArray(resSubscriptions?.shopify)) {
        dataSubscriptions = [...dataSubscriptions, ...resSubscriptions.shopify]; 
      }
      const dataPhysicals = result[4].data?.data?.items?.rows || [];
      const dataTradeable = result[1].data?.data?.tradeable?.items || {};
      const dataReadonly = result[1].data?.data?.readonly?.items || {};
      const dataEnergy = result[2].data?.data || {};
      const categories = result[5].data?.data?.categories || [];
      const dataPrime = result[6].data?.data?.items?.rows || [];
      const dataSkus = result[7].data?.data || [];
      const bonusSubs = resSubscriptions?.bonusSubs || []
      
      const subPayments = filterDataSubTop(
        dataSubscriptions,
        bonusSubs,
        [],
        resSubscriptions?.primeSubs || []
      );
      setItemsCategories(categories);
      setSkus(dataSkus)
      setDataTab({
        earners: dataEarners,
        primes: dataPrime,
        tradeable: dataTradeable,
        readOnly: dataReadonly,
        energy: dataEnergy,
        subscription: dataSubscriptions.slice(0, 4),
        bonusSub: bonusSubs?.slice(0, 4) || [],
        physical: dataPhysicals,
        subPayments: subPayments?.slice(0, 4) || [],
      });
    }).finally(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleViewAll = (tab) => {
    setPrePosition(PREPOSITION.HOME_ASSET)
    navigate(`/asset?type=${tab}`);
  };

  return (
    <div className="flex flex-col gap-[30px] lg:gap-[30px] xls:gap-[60px] lg:mt-[24px] xls:mt-[40px]">
      <div className="asset-block-home">
        <div
          className="flex items-center justify-between 
          px-[15px] py-[15px] lg:px-[40px] lg:py-[22px] xl:px-[40px] xl:py-[22px] xls:px-[50px] xls:py-[27px]"
        >
          <h3 className="text-base lg:text-[24px] text-[#272729] font-[600]">
            {T("Art")}
          </h3>
          <div
            onClick={() => handleViewAll("earner")}
            className="asset-block_action cursor-pointer flex text-sm leading-[20px] 
            lg:text-[16px]/[24px] font-[500] text-[#818181] justify-end items-center gap-[12px]
            "
          >
            {T("View All")}{" "}
            <span className="rotate-[-90deg]">
              <ArrowDownIcon />
            </span>
          </div>
        </div>
        <div className={`asset-block-items`}>
          {dataTab?.earners?.length > 0 ? (
            <>
              <div className="lg:grid lg:grid-cols-4 lg:gap-[22px] xls:gap-[27px]">
                {dataTab.earners.map((item, index) => (
                  <Item
                    key={index}
                    isHome={true}
                    itemData={item}
                    categoryTypes={itemsCategories}
                  />
                ))}
              </div>
            </>
          ) : (
            <>
              <div className="text-[#818181] pt-[20px] lg:pt-[20px] pb-[16px] flex-wrap text-sm lg:text-base flex justify-center items-center">
                {T("You haven't got anything yet.")}&nbsp;
                <a
                  href={`${user.store_shopify}?lang=${user.language}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-aia-red underline w-full lg:w-auto flex justify-center"
                >
                  {T("Go to Mall")}
                </a>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="asset-block-home">
        <div
          className="flex items-center justify-between 
          px-[15px] py-[15px] lg:px-[40px] lg:py-[22px] xl:px-[40px] xl:py-[22px] xls:px-[50px] xls:py-[27px]"
        >
          <h3 className="text-base lg:text-[24px] text-[#272729] font-[600]">
            {T("Art Prime")}
          </h3>
          <div
            onClick={() => handleViewAll("nft_prime")}
            className="asset-block_action cursor-pointer flex text-sm leading-[20px] 
            lg:text-[16px]/[24px] font-[500] text-[#818181] justify-end items-center gap-[12px]
            "
          >
            {T("View All")}{" "}
            <span className="rotate-[-90deg]">
              <ArrowDownIcon />
            </span>
          </div>
        </div>
        <div className={`asset-block-items`}>
          {dataTab?.primes?.length > 0 ? (
            <>
              <div className="lg:grid lg:grid-cols-3 lg:gap-[22px] xls:gap-[27px]">
                {dataTab.primes.map((item, index) => (
                  <ItemPrime
                    key={index}
                    isHome={true}
                    itemData={item}
                    categoryTypes={skus}
                  />
                ))}
              </div>
            </>
          ) : (
            <>
              <div className="text-[#818181] pt-[20px] lg:pt-[20px] pb-[16px] flex-wrap text-sm lg:text-base flex justify-center items-center">
                {T("You haven't got anything yet.")}&nbsp;
                <a
                  href={`${user.store_shopify}?lang=${user.language}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-aia-red underline w-full lg:w-auto flex justify-center"
                >
                  {T("Go to Mall")}
                </a>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="asset-block-home">
        <div
          className="flex items-center justify-between 
          px-[15px] py-[15px] lg:px-[40px] lg:py-[22px] xl:px-[40px] xl:py-[22px] xls:px-[50px] xls:py-[27px]"
        >
          <h3 className="text-base lg:text-[24px] text-[#272729] font-[600]">
            {T("Energy")}
          </h3>
          <div
            onClick={() => handleViewAll("energy")}
            className="asset-block_action cursor-pointer flex text-sm leading-[20px]
             lg:text-[16px]/[24px] font-[500] text-[#818181] justify-end items-center gap-[12px]"
          >
            {T("View All")}{" "}
            <span className="rotate-[-90deg]">
              <ArrowDownIcon />
            </span>
          </div>
        </div>
        <div className={`asset-block-items`}>
          {dataTab?.energy?.dogFood > 0 ? (
            <ItemTotal
              data={dataTab?.energy}
              isHome={true}
              handleClick={() => handleViewAll("energy")}
            />
          ) : (
            <>
              <div className="text-[#818181] pt-[20px] lg:pt-[20px] pb-[16px]  text-sm flex-wrap lg:text-base flex justify-center items-center">
                {T("You haven't got anything yet.")}&nbsp;
                <a
                  href={`${user.store_shopify}?lang=${user.language}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-aia-red underline  w-full lg:w-auto flex justify-center"
                >
                  {T("Go to Mall")}
                </a>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="asset-block-home">
        <div className="flex items-center justify-between px-[15px] py-[15px] lg:px-[40px] lg:py-[22px] xl:px-[40px] xl:py-[22px] xls:px-[50px] xls:py-[27px]">
          <h3 className="text-base lg:text-[24px]  text-[#272729] font-[600]">
            {T("Subscription")}
          </h3>
          <div
            onClick={() => handleViewAll("subscription")}
            className="asset-block_action cursor-pointer flex text-sm leading-[20px] 
            lg:text-[16px]/[24px] font-[500] text-[#818181] justify-end items-center gap-[12px]"
          >
            {T("View All")}{" "}
            <span className="rotate-[-90deg]">
              <ArrowDownIcon />
            </span>
          </div>
        </div>
        <div className={`asset-block-items`}>
          {dataTab?.subPayments?.length > 0 && (
            <>
              <div className="text-[16px] font-[600] mb-[15px] uppercase">
                {T("Upcomming Payment")}
              </div>
              <div className="hidden lg:grid lg:grid-cols-3 xl:grid-cols-4 xls:grid-cols-5 lg:gap-[22px] xls:gap-[27px] mb-[30px]">
                {dataTab?.subPayments.map((item, index) => (
                  <ItemSubCard key={index} itemData={item} isHome={true} />
                ))}
              </div>
              <div className="block lg:hidden">
                {dataTab?.subPayments.map((item, index) => (
                  <ItemSubCardMobile
                    key={index}
                    itemData={item}
                    handleClick={() => handleViewAll("subscription")}
                  />
                ))}
              </div>
            </>
          )}

          {dataTab?.subPayments?.length === 0 && (
            <>
              <div className="text-[#818181] pt-[20px] lg:pt-[20px] pb-[16px] text-sm flex-wrap lg:text-base flex justify-center items-center">
                {T(
                  "You haven't purchased any subscription yet. Find out more about Subscriptions."
                )}
              </div>
            </>
          )}
        </div>
      </div>
      <div className="asset-block-home">
        <div className="flex items-center justify-between px-[15px] py-[15px] lg:px-[40px] lg:py-[22px] xl:px-[40px] xl:py-[22px] xls:px-[50px] xls:py-[27px]">
          <h3 className="text-base lg:text-[24px] text-[#272729] font-[600]">
            {T("Other products")}
          </h3>
          <div
            onClick={() => handleViewAll("merchandise")}
            className="asset-block_action cursor-pointer flex text-sm leading-[20px] 
            lg:text-[16px]/[24px] font-[500] text-[#818181] justify-end items-center gap-[12px]"
          >
            {T("View All")}{" "}
            <span className="rotate-[-90deg]">
              <ArrowDownIcon />
            </span>
          </div>
        </div>
        <div className={`asset-block-items`}>
          {dataTab?.physical?.length > 0 ? (
            <>
              <div className="lg:grid lg:grid-cols-4 lg:gap-[22px] xls:gap-[27px]">
                {dataTab.physical.map((item, index) => (
                  <ItemMerchandise
                    key={index}
                    isHome={true}
                    itemData={item}
                    handleClick={() => handleViewAll("merchandise")}
                  />
                ))}
              </div>
            </>
          ) : (
            <>
              <div className="text-[#818181]  pt-[20px] lg:pt-[20px] pb-[16px] text-sm flex-wrap lg:text-base flex justify-center items-center">
                {T("You haven't got anything yet.")}&nbsp;
                <a
                  href={`${user.store_shopify}?lang=${user.language}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-aia-red underline w-full lg:w-auto flex justify-center"
                >
                  {T("Go to Mall")}
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
